import { c as _c } from "react/compiler-runtime";
import type { CartNotification } from '@libs/common-types';
import { CART_NOTIFICATIONS_STORAGE_KEY } from '@libs/core/constants';
import { useLocalStorage } from './index';
const useCartNotifications = () => {
  const $ = _c(3);
  const [notifications, setNotifications] = useLocalStorage(CART_NOTIFICATIONS_STORAGE_KEY);
  let t0;
  if ($[0] !== notifications || $[1] !== setNotifications) {
    t0 = {
      notifications,
      setNotifications
    };
    $[0] = notifications;
    $[1] = setNotifications;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export { useCartNotifications };